const EmptyRouterView = () => /* webpackChunkName: "EmptyRouterView" */ import("./../views/grd/EmptyRouterView.vue");
const Home = () => /* webpackChunkName: "Home" */ import("./../views/grd/Home.vue");
const ArchiveRequest = () => /* webpackChunkName: "ArchiveRequestHome" */ import("./../views/grd/archive_request/ArchiveRequestHome.vue");
const Document = () => /* webpackChunkName: "Document" */ import("@/views/general/Document.vue");

export const routes = [
  {
    path: "/grd",
    component: EmptyRouterView,
    children: [
      {
        path: "",
        name: "grdHome",
        component: Home,
      },

      {
        path: "solicitud-archivo",
        name: "grdArchiveRequest",
        component: ArchiveRequest,
      },
      {
        path: "documentacion",
        name: "grdDocumentation",
        component: Document,
      },
    ],
  },
];
